import * as Storage from "./Storage.ts";
var deviceId = Storage.localGet('deviceId');
if(deviceId===null || deviceId===undefined){
  deviceId = "web"+(new Date().getTime()).toString(36)+ Math.random().toString(36).substring(2);
  Storage.localSet('deviceId',deviceId);
}
export default deviceId;